// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"3c52672cc8b4590c","470":"4c19f9202454257f","601":"4c19f9202454257f"}[chunkId] + ".css";
};